import React, {useEffect, useRef} from 'react';
import Scrollable from '../../../../../elements/Scrollable';
import Screen from '../../../../Screen';
import QuestionHeader from '../../../common/QuestionHeader/QuestionHeader';
import OptionsKey from '../common/OptionsKey/OptionsKey';
import Graph from './Graph/Graph';
import stylesheet from './VerticalBarsGraph.module.scss';

const VerticalBarsGraph = props => {
    const {question, options, onKeyExceedsArea} = props,
        header = <QuestionHeader {...props} />,
        ref = useRef();

    useEffect(() => {
        const container = ref.current,
            child = container?.children[0];

        if (container?.offsetHeight < child?.offsetHeight) {
            onKeyExceedsArea();
        }
    }, [question, options, onKeyExceedsArea]);

    return (
        <Screen className={'LiveVoting'} header={header}>
            <div className={stylesheet.VerticalBarsGraph}>
                <Graph {...props} />
                <div ref={ref} className={stylesheet.keyWrapper}>
                    <OptionsKey {...props} />
                </div>
            </div>
        </Screen>
    );
};

export default VerticalBarsGraph;
